export default __webpack_public_path__ + "static/media/checked.b4f563a2.svg";